/* ==========================================================================
   Jacobslink storefront behaviour.

   Plain modules, no framework, no build step. Everything is delegated off
   document so sections re-rendered by the Section Rendering API keep working
   without re-binding.
   ========================================================================== */

(function () {
  'use strict';

  var root = document.documentElement;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  var pendingAdds = new WeakMap();
  var sectionCleanups = new Map();
  function onSectionUnload(element, cleanup) {
    var callbacks = sectionCleanups.get(element) || [];
    callbacks.push(cleanup);
    sectionCleanups.set(element, callbacks);
  }
  document.addEventListener('shopify:section:unload', function (event) {
    sectionCleanups.forEach(function (callbacks, element) {
      if (event.target === element || event.target.contains(element)) {
        callbacks.forEach(function (cleanup) { cleanup(); });
        delete element.dataset.jlReady;
        sectionCleanups.delete(element);
      }
    });
  });

  function money(cents) {
    var fmt = (window.JL && window.JL.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace('{{amount}}', whole + '.' + parts[1])
      .replace('{{amount_no_decimals}}', whole)
      .replace('{{amount_with_comma_separator}}', parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1])
      .replace('{{amount_no_decimals_with_comma_separator}}', parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
  }

  /* ------------------------------------------------------------------------
     Drawers and overlays
     ---------------------------------------------------------------------- */

  var lastFocus = null;

  function openLayer(el) {
    if (!el) return;
    $$('.jl-drawer.is-open, .jl-search-overlay.is-open, .jl-lightbox.is-open').forEach(function (other) { if (other !== el) closeLayer(other); });
    lastFocus = document.activeElement;
    $$('[data-jl-open]').forEach(function (button) { if (button.dataset.jlOpen === el.id) button.setAttribute('aria-expanded', 'true'); });
    el.inert = false;
    el.classList.add('is-open');
    el.removeAttribute('aria-hidden');
    root.style.overflow = 'hidden';
    var focusable = el.querySelector('[data-jl-predictive]') || el.querySelector('[autofocus], input, button, a[href]');
    if (focusable) { setTimeout(function () { focusable.focus(); }, 60); }
  }

  function closeLayer(el) {
    if (!el) return;
    el.classList.remove('is-open');
    $$('[data-jl-open]').forEach(function (button) { if (button.dataset.jlOpen === el.id) button.setAttribute('aria-expanded', 'false'); });
    el.setAttribute('aria-hidden', 'true');
    el.inert = true;
    if (!document.querySelector('.jl-drawer.is-open, .jl-search-overlay.is-open, .jl-lightbox.is-open')) {
      root.style.overflow = '';
    }
    if (lastFocus && lastFocus.focus) { lastFocus.focus(); }
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-jl-open]');
    if (opener) {
      e.preventDefault();
      openLayer(document.getElementById(opener.getAttribute('data-jl-open')));
      return;
    }
    var closer = e.target.closest('[data-jl-close]');
    if (closer) {
      e.preventDefault();
      closeLayer(closer.closest('.jl-drawer, .jl-search-overlay, .jl-lightbox'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Tab') {
      var dialog = document.querySelector('.jl-lightbox.is-open, .jl-search-overlay.is-open, .jl-drawer.is-open');
      if (dialog) {
        var items = $$('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex="0"]', dialog)
          .filter(function (el) { return el.getClientRects().length && !el.closest('[hidden], [inert]'); });
        var first = items[0], last = items[items.length - 1];
        if (e.shiftKey && (document.activeElement === first || !dialog.contains(document.activeElement))) { e.preventDefault(); if (last) last.focus(); }
        else if (!e.shiftKey && (document.activeElement === last || !dialog.contains(document.activeElement))) { e.preventDefault(); if (first) first.focus(); }
      }
    }
    if (e.key !== 'Escape') return;
    var open = document.querySelector('.jl-lightbox.is-open, .jl-search-overlay.is-open, .jl-drawer.is-open');
    if (open) closeLayer(open);
  });

  /* ------------------------------------------------------------------------
     Announcement rotation. Matches the homepage crossfade rather than a slide.
     ---------------------------------------------------------------------- */

  function startAnnouncements() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    $$('[data-jl-rotate]').forEach(function (wrap) {
      if (wrap.dataset.jlReady) return;
      wrap.dataset.jlReady = 'true';
      var slides = $$('.jl-head__slide', wrap);
      if (slides.length < 2) return;

      var fallback = parseFloat(wrap.getAttribute('data-jl-rotate')) || 5;
      var pausable = wrap.hasAttribute('data-jl-rotate-pause');
      var i = 0;
      var timer = null;
      var paused = false;

      // A timeout chain rather than one interval, so a message that sets its
      // own "seconds shown" holds the band for exactly that long.
      function hold(index) {
        var own = parseFloat(slides[index].getAttribute('data-seconds'));
        return (own > 0 ? own : fallback) * 1000;
      }

      function advance() {
        slides[i].classList.remove('is-on');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-on');
        schedule();
      }

      function schedule() {
        clearTimeout(timer);
        if (paused || !wrap.isConnected) return;
        timer = setTimeout(advance, hold(i));
      }

      if (pausable) {
        wrap.addEventListener('mouseenter', function () {
          paused = true;
          clearTimeout(timer);
        });
        wrap.addEventListener('mouseleave', function () {
          paused = false;
          schedule();
        });
      }

      // A hidden tab should not burn through the whole rotation.
      function visibilityChanged() {
        paused = document.hidden;
        schedule();
      }
      document.addEventListener('visibilitychange', visibilityChanged);
      onSectionUnload(wrap, function () {
        clearTimeout(timer);
        document.removeEventListener('visibilitychange', visibilityChanged);
      });

      schedule();
    });
  }

  /* ------------------------------------------------------------------------
     Quantity steppers
     ---------------------------------------------------------------------- */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-jl-qty]');
    if (!btn) return;
    e.preventDefault();
    var input = $('input', btn.parentNode);
    if (!input) return;
    var step = btn.getAttribute('data-jl-qty') === 'up' ? 1 : -1;
    var min = parseInt(input.getAttribute('min'), 10) || 0;
    var next = (parseInt(input.value, 10) || 0) + step;
    if (next < min) next = min;
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ------------------------------------------------------------------------
     Product gallery
     ---------------------------------------------------------------------- */

  function showMedia(gallery, id) {
    $$('.jl-gallery__slide', gallery).forEach(function (slide) {
      slide.classList.toggle('is-on', slide.getAttribute('data-media-id') === String(id));
    });
    $$('.jl-gallery__thumb', gallery).forEach(function (thumb) {
      thumb.setAttribute('aria-current', thumb.getAttribute('data-media-id') === String(id) ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('.jl-gallery__thumb');
    if (thumb) {
      e.preventDefault();
      showMedia(thumb.closest('.jl-gallery'), thumb.getAttribute('data-media-id'));
      return;
    }
    var zoom = e.target.closest('[data-jl-zoom]');
    if (zoom) {
      e.preventDefault();
      var gallery = zoom.closest('.jl-gallery');
      var current = $('.jl-gallery__slide.is-on img', gallery);
      var box = document.getElementById('jl-lightbox');
      if (current && box) {
        $('img', box).src = current.getAttribute('data-zoom-src') || current.src;
        $('img', box).alt = current.alt || '';
        openLayer(box);
      }
    }
  });

  /* ------------------------------------------------------------------------
     Variant picker. Matching happens against the variant JSON the section
     prints, so switching an option never waits on a round trip.
     ---------------------------------------------------------------------- */

  function readOptions(scope) {
    return $$('[data-jl-option]', scope)
      .filter(function (input) { return input.checked || input.tagName === 'SELECT'; })
      .map(function (input) { return input.value; });
  }

  function findVariant(variants, chosen) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var match = true;
      for (var j = 0; j < chosen.length; j++) {
        if (v.options[j] !== chosen[j]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  function updateProduct(section) {
    var json = $('[data-jl-variant-json]', section);
    if (!json) return;
    var data = JSON.parse(json.textContent);
    var chosen = readOptions(section);
    var variant = findVariant(data, chosen);

    // Only products without their own description follow the selected variant.
    if (section.hasAttribute('data-jl-variant-description-fallback')) {
      var descriptionHtml = variant ? (variant.description_html || '') : '';
      var descriptionExcerpt = variant ? (variant.description_excerpt || '') : '';
      $$('[data-jl-description-content]', section).forEach(function (element) {
        element.innerHTML = descriptionHtml;
      });
      $$('[data-jl-description-region]', section).forEach(function (element) {
        element.hidden = !descriptionHtml;
      });
      $$('[data-jl-description-summary]', section).forEach(function (element) {
        element.hidden = !descriptionExcerpt;
        var text = $('p', element);
        if (text) text.textContent = descriptionExcerpt;
      });
    }

    var idInput = $('[data-jl-variant-id]', section);
    var addBtn = $('[data-jl-add]', section);
    var priceBox = $('[data-jl-cost]', section);
    var stock = $('[data-jl-stock]', section);
    var sku = $('[data-jl-sku]', section);
    var pending = addBtn && pendingAdds.get(addBtn.form);
    if (pending) pending.available = !!(variant && variant.available);

    // Grey out option values that do not exist in any variant with the
    // currently chosen values to their left.
    $$('[data-jl-option]', section).forEach(function (input) {
      if (input.tagName === 'SELECT') return;
      var idx = parseInt(input.getAttribute('data-option-index'), 10);
      var test = chosen.slice();
      test[idx] = input.value;
      var candidate = findVariant(data, test.slice(0, idx + 1));
      var wrap = input.parentNode;
      wrap.classList.toggle('jl-opt--soldout', !candidate || !candidate.available);
    });

    $$('[data-option-selected]', section).forEach(function (label) {
      label.textContent = chosen[Number(label.dataset.optionSelected)] || '';
    });
    var payment = $('.shopify-payment-button', section);
    if (payment) payment.hidden = !variant || !variant.available;
    if (idInput) { idInput.disabled = !variant || !variant.available; idInput.value = variant ? variant.id : ''; }

    if (!variant) {
      if (priceBox) priceBox.textContent = window.JL.strings.unavailable;
      if (addBtn) {
        addBtn.setAttribute('disabled', 'disabled');
        addBtn.textContent = addBtn.getAttribute('data-unavailable') || 'Unavailable';
      }
      if (stock) stock.hidden = true;
      return;
    }

    if (idInput) idInput.value = variant.id;

    if (addBtn) {
      if (variant.available) {
        addBtn.disabled = !!pending;
        addBtn.textContent = addBtn.getAttribute('data-add') || 'Add to cart';
      } else {
        addBtn.setAttribute('disabled', 'disabled');
        addBtn.textContent = addBtn.getAttribute('data-soldout') || 'Sold out';
      }
    }

    if (priceBox) {
      var html = '<span class="jl-cost__now">' + variant.price_formatted + '</span>';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html += '<s class="jl-cost__was">' + variant.compare_formatted + '</s>';
        priceBox.classList.add('jl-cost--sale');
      } else {
        priceBox.classList.remove('jl-cost--sale');
      }
      if (variant.unit_price_measurement) {
        var measure = variant.unit_price_measurement;
        html += '<span class="jl-cost__unit">' + variant.unit_price_formatted + ' / ' +
          (measure.reference_value === 1 ? '' : measure.reference_value) + measure.reference_unit + '</span>';
      }
      priceBox.innerHTML = '<div class="jl-cost">' + html + '</div>';
    }

    if (stock) {
      stock.hidden = false;
      stock.classList.toggle('jl-stock--out', !variant.available);
      stock.textContent = variant.available
        ? (stock.getAttribute('data-in') || 'In stock')
        : (stock.getAttribute('data-out') || 'Sold out');
    }

    if (sku) { sku.textContent = variant.sku || ''; }

    if (variant.featured_media_id) {
      var gallery = $('.jl-gallery', section);
      if (gallery) showMedia(gallery, variant.featured_media_id);
    }

    if (history.replaceState && section.getAttribute('data-jl-url')) {
      history.replaceState({}, '', section.getAttribute('data-jl-url') + '?variant=' + variant.id);
    }
  }

  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-jl-option]')) return;
    var section = e.target.closest('[data-jl-product]');
    if (section) updateProduct(section);
  });

  /* ------------------------------------------------------------------------
     Cart. Everything goes through the AJAX API and asks the Section Rendering
     API for fresh markup, so the drawer, the icon count and the cart page all
     stay in step from one response.
     ---------------------------------------------------------------------- */

  function sectionIds() {
    return $$('[data-jl-cart-section]').map(function (el) {
      return el.getAttribute('data-jl-cart-section');
    });
  }

  function paintSections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      $$('[data-jl-cart-section="' + id + '"]').forEach(function (target) {
        var fresh = new DOMParser().parseFromString(sections[id], 'text/html');
        var source = fresh.querySelector('[data-jl-cart-section="' + id + '"]');
        if (source) target.innerHTML = source.innerHTML;
      });
    });
  }

  function refreshCount(count) {
    $$('[data-jl-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count < 1;
    });
  }

  function cartRequest(url, body) {
    body.sections = sectionIds().join(',');
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (data) {
      if (!r.ok) throw new Error(data.description || data.message || window.JL.strings.cartError);
      return data;
    }); });
  }

  var changingCart = false;
  function changeCart(control, quantity) {
    if (changingCart) return;
    changingCart = true;
    var scopes = $$('[data-jl-cart-section]');
    scopes.forEach(function (scope) { scope.classList.add('jl-loading'); scope.inert = true; });
    var key = control.getAttribute('data-jl-line-key');
    var oldQuantity = control.getAttribute('data-jl-original-quantity');
    var note = $('#jl-cart-note');
    var noteValue = note ? note.value : null;
    $$('[data-jl-cart-error]').forEach(function (box) { box.hidden = true; });
    cartRequest(window.Shopify.routes.root + 'cart/change.js', { id: key, quantity: quantity })
      .then(function (data) {
        paintSections(data.sections);
        refreshCount(data.item_count);
        var freshNote = $('#jl-cart-note');
        if (freshNote && noteValue !== null) freshNote.value = noteValue;
        document.dispatchEvent(new CustomEvent('jl:cart:updated', { detail: data }));
      })
      .catch(function (error) {
        if (oldQuantity !== null) control.value = oldQuantity;
        $$('[data-jl-cart-error]').forEach(function (box) { box.hidden = false; box.textContent = error.message; });
      })
      .finally(function () {
        changingCart = false;
        scopes.forEach(function (scope) { scope.classList.remove('jl-loading'); scope.inert = false; });
      });
  }

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-jl-line-qty]');
    if (!input) return;
    var quantity = Number(input.value);
    if (!Number.isInteger(quantity) || quantity < 0) { input.value = input.dataset.jlOriginalQuantity; return; }
    changeCart(input, quantity);
  });

  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-jl-line-remove]');
    if (!remove) return;
    e.preventDefault();
    changeCart(remove, 0);
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM' || !form.closest('[data-jl-add-form]')) return;
    e.preventDefault();
    var btn = $('[data-jl-add]', form);
    if (pendingAdds.has(form) || (btn && btn.disabled)) return;
    var pending = { available: true };
    pendingAdds.set(form, pending);
    var added = false;
    var openingCart = false;
    var failureMessage = window.JL.strings.cartError;
    var errBox = $('[data-jl-add-error]', form);
    if (errBox) { errBox.hidden = true; errBox.textContent = ''; }
    if (btn) btn.classList.add('jl-loading');

    if (btn) btn.disabled = true;
    var body = new FormData(form);
    body.set('sections', sectionIds().join(','));
    body.set('sections_url', window.location.pathname);

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: body
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          failureMessage = res.data.description || res.data.message || failureMessage;
          throw new Error(failureMessage);
        }
        added = true;
        paintSections(res.data.sections);
        return fetch(window.Shopify.routes.root + 'cart.js')
          .then(function (r) { if (!r.ok) throw new Error('Cart refresh failed'); return r.json(); })
          .then(function (cart) {
            refreshCount(cart.item_count);
            openLayer(document.getElementById('jl-cart-drawer'));
            document.dispatchEvent(new CustomEvent('jl:cart:updated', { detail: cart }));
          });
      })
      .catch(function (error) {
        // The purchase succeeded. Show Shopify's cart rather than invite a retry.
        if (added) {
          openingCart = true;
          window.location.assign((window.JL.routes && window.JL.routes.cart) || window.Shopify.routes.root + 'cart');
          return;
        }
        if (errBox) { errBox.hidden = false; errBox.textContent = failureMessage; }
      })
      .finally(function () {
        if (openingCart) return;
        pendingAdds.delete(form);
        if (btn) { btn.classList.remove('jl-loading'); btn.disabled = !pending.available; }
      });
  });

  /* ------------------------------------------------------------------------
     Predictive search
     ---------------------------------------------------------------------- */

  var searches = new WeakMap();

  document.addEventListener('input', function (e) {
    var input = e.target.closest('[data-jl-predictive]');
    if (!input) return;
    var results = document.getElementById(input.getAttribute('data-jl-predictive'));
    if (!results) return;
    var term = input.value.trim();

    var previous = searches.get(input);
    if (previous) { clearTimeout(previous.timer); previous.controller.abort(); }
    var request = { controller: new AbortController(), timer: null };
    searches.set(input, request);
    results.hidden = true;
    results.innerHTML = '';
    if (term.length < 2) { results.hidden = true; results.innerHTML = ''; return; }

    request.timer = setTimeout(function () {
      var url = window.Shopify.routes.root + 'search/suggest?q=' + encodeURIComponent(term) +
        '&resources[type]=product,page,article&resources[limit]=6&section_id=jl-predictive';
      fetch(url, { signal: request.controller.signal })
        .then(function (r) { if (!r.ok) throw new Error('Search failed'); return r.text(); })
        .then(function (html) {
          if (searches.get(input) !== request || !input.isConnected) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var body = doc.querySelector('[data-jl-predictive-results]');
          results.innerHTML = body ? body.innerHTML : '';
          results.hidden = !body;
        })
        .catch(function () {
          if (searches.get(input) !== request) return;
          results.hidden = true;
          results.innerHTML = '';
        });
    }, 250);
  });

  /* ------------------------------------------------------------------------
     Facets. Submitting the filter form swaps the grid in place rather than
     reloading, and the address bar keeps up so back still works.
     ---------------------------------------------------------------------- */

  var facetRequest = null;
  var facetSequence = 0;
  function loadFacets(url, push) {
    var catalog = $('[data-jl-catalog]');
    if (!catalog) { window.location.href = url; return; }
    if (facetRequest) facetRequest.abort();
    facetRequest = new AbortController();
    var sequence = ++facetSequence;
    var focusedId = document.activeElement.id;
    var openDetails = $$('details[open][id]', catalog).map(function (el) { return el.id; });
    catalog.setAttribute('aria-busy', 'true');
    var error = $('[data-jl-facet-error]', catalog);
    if (error) error.hidden = true;
    fetch(url, { signal: facetRequest.signal })
      .then(function (r) { if (!r.ok) throw new Error('filter request'); return r.text(); })
      .then(function (html) {
        if (sequence !== facetSequence) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-jl-catalog]');
        if (!fresh) throw new Error('missing catalog');
        catalog.innerHTML = fresh.innerHTML;
        $$('details[id]', catalog).forEach(function (el) { el.open = openDetails.indexOf(el.id) !== -1; });
        var focus = focusedId && document.getElementById(focusedId);
        if (focus) focus.focus({ preventScroll: true });
        if (push) history.pushState({ jlFacets: url }, '', url);
      })
      .catch(function (err) {
        if (err.name === 'AbortError' || sequence !== facetSequence) return;
        error = $('[data-jl-facet-error]', catalog);
        if (!error) { error = document.createElement('p'); error.className = 'jl-alert jl-alert--error'; error.setAttribute('role','alert'); error.setAttribute('data-jl-facet-error',''); catalog.prepend(error); }
        error.hidden = false;
        error.textContent = window.JL.strings.filterError;
      })
      .finally(function () { if (sequence === facetSequence) catalog.removeAttribute('aria-busy'); });
  }

  function submitFacets(form) {
    if (!form.reportValidity()) return;
    var params = new URLSearchParams(new FormData(form));
    var clean = new URLSearchParams();
    params.forEach(function (value, key) { if (value !== '') clean.append(key, value); });
    loadFacets(window.location.pathname + '?' + clean.toString(), true);
  }

  document.addEventListener('change', function (e) {
    var form = e.target.closest('[data-jl-facet-form]');
    if (form) submitFacets(form);
  });
  document.addEventListener('submit', function (e) {
    if (!e.target.matches('[data-jl-facet-form]')) return;
    e.preventDefault();
    submitFacets(e.target);
  });

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-jl-facet-link]');
    if (!link) return;
    e.preventDefault();
    loadFacets(link.href, true);
  });

  window.addEventListener('popstate', function (e) {
    if ($('[data-jl-catalog]')) loadFacets(window.location.href, false);
  });

  /* ------------------------------------------------------------------------
     Testimonial rails: starting one clip stops whichever was already running,
     so a row of videos never turns into several people talking at once.
     ---------------------------------------------------------------------- */

  document.addEventListener('play', function (e) {
    if (!e.target.matches || !e.target.matches('video')) return;
    $$('video').forEach(function (other) {
      if (other !== e.target && !other.paused) other.pause();
    });
  }, true);

  /* ------------------------------------------------------------------------
     Floating audio player
     ---------------------------------------------------------------------- */

  function startAudio() {
    $$('[data-jl-audio]').forEach(function (box) {
      if (box.dataset.jlReady) return;
      box.dataset.jlReady = 'true';
      var audio = $('audio', box);
      var toggle = $('[data-jl-audio-toggle]', box);
      var icon = $('[data-jl-audio-icon]', box);
      var fill = $('[data-jl-audio-fill]', box);
      var bar = $('[data-jl-audio-bar]', box);
      var volume = $('[data-jl-audio-volume]', box);
      var close = $('[data-jl-audio-close]', box);
      var mute = $('[data-jl-audio-mute]', box);
      var muteIcon = $('[data-jl-audio-mute-icon]', box);
      if (!audio || !toggle) return;

      var playLabel = toggle.getAttribute('aria-label');

      function paint() {
        var on = !audio.paused;
        box.classList.toggle('is-playing', on);
        icon.innerHTML = on ? '&#10073;&#10073;' : '&#9654;';
        toggle.setAttribute('aria-label', on ? 'Pause' : playLabel);
      }

      toggle.addEventListener('click', function () {
        if (audio.paused) audio.play().catch(function () {});
        else audio.pause();
      });

      audio.addEventListener('play', paint);
      audio.addEventListener('pause', paint);

      audio.addEventListener('timeupdate', function () {
        if (!audio.duration) return;
        fill.style.width = ((audio.currentTime / audio.duration) * 100) + '%';
      });

      if (bar) {
        bar.addEventListener('click', function (e) {
          if (!audio.duration) return;
          var box2 = bar.getBoundingClientRect();
          audio.currentTime = ((e.clientX - box2.left) / box2.width) * audio.duration;
        });
      }

      if (volume) {
        volume.addEventListener('input', function () { audio.volume = parseFloat(volume.value); });
      }

      /* --------------------------------------------------------------
         One remembered state for the player, so a choice made on any page
         holds everywhere else. Mute and pause live in localStorage because
         both can be undone from the player's own buttons. Dismissal lives in
         sessionStorage instead: there is no control to bring the player back,
         so making it permanent would orphan it for good.
         -------------------------------------------------------------- */
      var KEY = 'jl-audio-state';

      function readState() {
        var out = {};
        try {
          var local = JSON.parse(localStorage.getItem(KEY) || '{}');
          if (local && typeof local === 'object') out = local;
        } catch (e) {}
        try { out.dismissed = sessionStorage.getItem(KEY + '-dismissed') === '1'; } catch (e) {}
        return out;
      }

      function remember(patch) {
        try {
          var cur = {};
          try { cur = JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) {}
          if ('dismissed' in patch) {
            sessionStorage.setItem(KEY + '-dismissed', patch.dismissed ? '1' : '0');
            delete patch.dismissed;
          }
          for (var k in patch) cur[k] = patch[k];
          localStorage.setItem(KEY, JSON.stringify(cur));
        } catch (e) {}
      }

      function paintMute() {
        if (!mute) return;
        mute.setAttribute('aria-pressed', audio.muted ? 'true' : 'false');
        mute.setAttribute('aria-label', audio.muted ? 'Unmute' : 'Mute');
        if (muteIcon) muteIcon.innerHTML = audio.muted ? '&#128263;' : '&#128266;';
      }

      var state = readState();

      // Keep controls initialized so the mobile Music disclosure can reopen it.
      if (state.dismissed) {
        box.hidden = true;
      }

      audio.muted = typeof state.muted === 'boolean'
        ? state.muted
        : box.hasAttribute('data-start-muted');
      paintMute();

      if (mute) {
        mute.addEventListener('click', function () {
          audio.muted = !audio.muted;
          remember({ muted: audio.muted });
          paintMute();
        });
      }

      if (close) {
        close.addEventListener('click', function () {
          audio.pause();
          box.hidden = true;
          remember({ dismissed: true });
        });
      }

      // Recorded from the media events rather than the button, so pausing by
      // any route is remembered, including the video search page stopping it.
      audio.addEventListener('play', function () { remember({ paused: false }); });
      audio.addEventListener('pause', function () { remember({ paused: true }); });

      // Autoplay is a request, not a guarantee, and it is not even attempted
      // if the visitor already paused it somewhere else.
      if (box.hasAttribute('data-autoplay') && state.paused !== true && !state.dismissed) {
        audio.play().catch(function () {});
      }

      paint();
    });
  }

  /* ------------------------------------------------------------------------
     Slideshow. The timer stops for good the moment anyone takes control, so
     the slide someone chose does not slide away under them.
     ---------------------------------------------------------------------- */

  function startSlideshows() {
    $$('[data-jl-slideshow]').forEach(function (box) {
      if (box.dataset.jlReady) return;
      box.dataset.jlReady = 'true';
      var slides = $$('[data-jl-slide]', box);
      var dots = $$('[data-jl-slide-to]', box);
      if (slides.length < 2) return;

      var i = 0;
      var timer = null;
      var seconds = parseFloat(box.getAttribute('data-seconds'));

      function show(next) {
        i = (next + slides.length) % slides.length;
        slides.forEach(function (slide, n) { slide.classList.toggle('is-on', n === i); });
        dots.forEach(function (dot, n) {
          dot.classList.toggle('is-on', n === i);
          dot.setAttribute('aria-selected', n === i ? 'true' : 'false');
        });
      }

      function stop() {
        clearInterval(timer);
        timer = null;
      }
      onSectionUnload(box, stop);

      if (seconds > 0) {
        timer = setInterval(function () { if (!box.isConnected) { stop(); return; } show(i + 1); }, seconds * 1000);
        box.addEventListener('mouseenter', function () { clearInterval(timer); });
        box.addEventListener('mouseleave', function () {
          if (timer !== null) timer = setInterval(function () { if (!box.isConnected) { stop(); return; } show(i + 1); }, seconds * 1000);
        });
      }

      box.addEventListener('click', function (e) {
        var to = e.target.closest('[data-jl-slide-to]');
        var prev = e.target.closest('[data-jl-slide-prev]');
        var next = e.target.closest('[data-jl-slide-next]');
        if (!to && !prev && !next) return;
        stop();
        if (to) show(dots.indexOf(to));
        else show(i + (next ? 1 : -1));
      });
    });
  }

  /* ------------------------------------------------------------------------
     Footer menus. They ship open so the footer is complete without
     JavaScript; here they fold below the breakpoint and reopen above it, and
     a menu the visitor opened by hand on a phone is left alone.
     ---------------------------------------------------------------------- */

  function syncFooterMenus() {
    var small = window.matchMedia('(max-width: 749px)').matches;
    $$('[data-jl-foot-collapse]').forEach(function (details) {
      if (small) {
        if (!details.dataset.jlTouched) details.open = false;
      } else {
        details.open = true;
        delete details.dataset.jlTouched;
      }
    });
  }

  document.addEventListener('toggle', function (e) {
    var details = e.target.closest ? e.target.closest('[data-jl-foot-collapse]') : null;
    if (details && window.matchMedia('(max-width: 749px)').matches) {
      details.dataset.jlTouched = '1';
    }
  }, true);

  window.addEventListener('resize', syncFooterMenus);

  /* ------------------------------------------------------------------------
     Product shelf arrows. The track is a native scroller, so the arrows only
     nudge it by one card and then let the browser's own snapping finish.
     ---------------------------------------------------------------------- */

  function shelfStep(track) {
    var first = track.firstElementChild;
    if (!first) return track.clientWidth;
    var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    return first.getBoundingClientRect().width + gap;
  }

  function syncShelfArrows(shelf) {
    var track = $('[data-jl-shelf-track]', shelf);
    var prev = $('[data-jl-shelf-prev]', shelf);
    var next = $('[data-jl-shelf-next]', shelf);
    if (!track) return;
    var max = track.scrollWidth - track.clientWidth - 1;
    if (prev) prev.disabled = track.scrollLeft <= 0;
    if (next) next.disabled = track.scrollLeft >= max;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-jl-shelf-prev], [data-jl-shelf-next]');
    if (!btn) return;
    e.preventDefault();
    var shelf = btn.closest('[data-jl-shelf]');
    var track = $('[data-jl-shelf-track]', shelf);
    if (!track) return;
    var dir = btn.hasAttribute('data-jl-shelf-prev') ? -1 : 1;
    track.scrollBy({ left: dir * shelfStep(track), behavior: 'smooth' });
  });

  function startShelves() {
    $$('[data-jl-shelf]').forEach(function (shelf) {
      if (shelf.dataset.jlReady) return;
      shelf.dataset.jlReady = 'true';
      var track = $('[data-jl-shelf-track]', shelf);
      if (!track) return;
      syncShelfArrows(shelf);
      track.addEventListener('scroll', function () { syncShelfArrows(shelf); }, { passive: true });
      function resizeShelf() { syncShelfArrows(shelf); }
      window.addEventListener('resize', resizeShelf);
      onSectionUnload(shelf, function () {
        window.removeEventListener('resize', resizeShelf);
        surrender();
      });

      // Optional self-advancing rail. It wraps to the start at the end, stops
      // while the cursor is over it, and gives up for good once someone
      // scrolls or presses an arrow themselves.
      var auto = parseFloat(shelf.getAttribute('data-jl-shelf-auto'));
      if (!(auto > 0)) return;

      var timer = setInterval(step, auto * 1000);

      function step() {
        if (!shelf.isConnected) { surrender(); return; }
        var max = track.scrollWidth - track.clientWidth - 1;
        if (track.scrollLeft >= max) track.scrollTo({ left: 0, behavior: 'smooth' });
        else track.scrollBy({ left: shelfStep(track), behavior: 'smooth' });
      }

      function surrender() {
        clearInterval(timer);
        timer = null;
      }

      shelf.addEventListener('mouseenter', function () { if (timer) clearInterval(timer); });
      shelf.addEventListener('mouseleave', function () {
        if (timer) timer = setInterval(step, auto * 1000);
      });
      track.addEventListener('pointerdown', surrender);
      track.addEventListener('wheel', surrender, { passive: true });
      $$('[data-jl-shelf-prev], [data-jl-shelf-next]', shelf).forEach(function (btn) {
        btn.addEventListener('click', surrender);
      });
    });
  }

  /* ------------------------------------------------------------------------
     Product recommendations. Shopify only fills the recommendations object on
     its own endpoint, so the section ships empty and is filled here.
     ---------------------------------------------------------------------- */

  function loadRecommendations() {
    $$('[data-jl-recommendations]').forEach(function (box) {
      if (box.dataset.jlReady) return;
      box.dataset.jlReady = 'true';
      var url = box.getAttribute('data-url');
      if (!url) return;
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-jl-recommendations]');
          if (fresh && fresh.innerHTML.trim()) box.innerHTML = fresh.innerHTML;
        })
        .catch(function () {});
    });
  }

  /* Keep the product reviews in view while recommendations and Loox render. */
  var linkedReviewsStarted = false;
  function alignLinkedReviews() {
    if (!document.body.classList.contains('template-product') ||
        new URLSearchParams(window.location.search).get('jl_reviews') !== '1' || linkedReviewsStarted) return;
    linkedReviewsStarted = true;

    var stopped = false;
    var scheduled = false;
    var observer = null;
    var timers = [];
    var inputs = ['wheel', 'touchstart', 'pointerdown', 'keydown'];

    function stop() {
      if (stopped) return;
      stopped = true;
      if (observer) observer.disconnect();
      timers.forEach(clearTimeout);
      inputs.forEach(function (type) { window.removeEventListener(type, stop); });
    }

    function align() {
      scheduled = false;
      if (stopped) return;
      var reviews = document.getElementById('looxReviews');
      if (!reviews) return;
      var headerHeight = parseFloat(getComputedStyle(root).getPropertyValue('--jl-sticky-header-height')) || 0;
      var desiredTop = Math.max(24, headerHeight + 16);
      var distance = reviews.getBoundingClientRect().top - desiredTop;
      if (Math.abs(distance) > 12) window.scrollTo(0, Math.max(0, window.scrollY + distance));
    }

    function schedule() {
      if (!stopped && !scheduled) {
        scheduled = true;
        requestAnimationFrame(align);
      }
    }

    inputs.forEach(function (type) { window.addEventListener(type, stop, { once: true, passive: true }); });
    if (window.MutationObserver) {
      observer = new MutationObserver(schedule);
      observer.observe(document.getElementById('jl-main') || document.body, { childList: true, subtree: true });
    }
    [0, 200, 500, 1000, 1800, 3000, 5000, 8000].forEach(function (delay) {
      timers.push(setTimeout(schedule, delay));
    });
    timers.push(setTimeout(stop, 10000));
    window.addEventListener('load', schedule, { once: true });
    schedule();
  }

  /* ------------------------------------------------------------------------
     Share button
     ---------------------------------------------------------------------- */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-jl-share]');
    if (!btn) return;
    e.preventDefault();
    var url = btn.getAttribute('data-jl-share') || window.location.href;
    if (navigator.share) {
      navigator.share({ title: document.title, url: url });
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function () {
        var label = $('[data-jl-share-label]', btn);
        if (!label) return;
        var original = label.textContent;
        label.textContent = btn.getAttribute('data-copied') || 'Link copied';
        setTimeout(function () { label.textContent = original; }, 2000);
      });
    }
  });

  /* ------------------------------------------------------------------------
     Localization selects submit their own form.
     ---------------------------------------------------------------------- */

  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-jl-localization]');
    if (select) select.form.submit();
  });

  /* ---------------------------------------------------------------------- */

  function startStickyHeader() {
    $$('.jl-head--sticky').forEach(function (header) {
      if (header.dataset.jlReady) return;
      var section = header.closest('.shopify-section-group-header-group');
      var band = $('.jl-head__band', header);
      if (!section || !band) return;
      header.dataset.jlReady = 'true';
      // A zero-height flow anchor stays put while the sticky section moves.
      var anchor = document.createElement('div');
      anchor.setAttribute('aria-hidden', 'true');
      anchor.setAttribute('data-jl-sticky-anchor', '');
      anchor.style.cssText = 'display:block;height:0;flex:0 0 0;margin:0;padding:0;';
      section.before(anchor);
      var stickyStart = 0;
      var stuck = header.classList.contains('is-stuck');
      function onScroll() {
        var scrollTop = Math.max(0, window.scrollY || 0);
        var next = scrollTop >= (stuck ? Math.max(0, stickyStart - 8) : stickyStart);
        if (scrollTop === 0 && stickyStart > 0) next = false;
        if (next === stuck) return;
        stuck = next;
        header.classList.toggle('is-stuck', stuck);
      }
      function measure() {
        stickyStart = Math.max(0, Math.round(anchor.getBoundingClientRect().top + window.scrollY + band.offsetTop));
        section.style.setProperty('--jl-header-scroll-away', band.offsetTop + 'px');
        root.style.setProperty('--jl-sticky-header-height', (header.offsetHeight - band.offsetTop) + 'px');
        onScroll();
      }
      var observer = window.ResizeObserver ? new ResizeObserver(measure) : null;
      if (observer) observer.observe(header);
      window.addEventListener('resize', measure);
      window.addEventListener('scroll', onScroll, { passive: true });
      measure();
      onSectionUnload(header, function () {
        if (observer) observer.disconnect();
        window.removeEventListener('resize', measure);
        window.removeEventListener('scroll', onScroll);
        anchor.remove();
        section.style.removeProperty('--jl-header-scroll-away');
        root.style.removeProperty('--jl-sticky-header-height');
        header.classList.remove('is-stuck');
      });
    });
  }

  function boot() {
    $$('[data-jl-open]').forEach(function (button) { button.setAttribute('aria-controls', button.dataset.jlOpen); button.setAttribute('aria-expanded', 'false'); });
    $$('.jl-drawer, .jl-search-overlay, .jl-lightbox').forEach(function (el) { el.inert = !el.classList.contains('is-open'); });
    startStickyHeader();
    startAnnouncements();
    loadRecommendations();
    alignLinkedReviews();
    startShelves();
    startSlideshows();
    startAudio();
    syncFooterMenus();
  }

  document.addEventListener('shopify:section:load', boot);
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
